// extracted by mini-css-extract-plugin
export var bannerRatioHigh = "main-layout-module--banner-ratio-high--472ws";
export var bannerRatioNormal = "main-layout-module--banner-ratio-normal--WTIiU";
export var cookiesModule = "main-layout-module--cookies-module---fzIj";